export default "__VITE_ASSET__3f995987__"